export const listCompany = {
  ONE_LAESING: [1, "บริษัท วัน ลิสซิ่ง จำกัด(สำนักงานใหญ่)"],
  ONE_MONEY: [2, "บริษัท วัน มันนี่ จำกัด(สำนักงานใหญ่)"],
  KSM: [3, "บริษัท เค.เอส.เอ็ม.บิลเลี่ยนแนร์ จำกัด(สำนักงานใหญ่)"],
  CAL2009: [4, "บริษัท ซี เอ แอล 2009 จำกัด ไป บริษัท วัน ลิสซิ่ง จำกัด"],
  CAL_LAESING: [6, "บริษัท ซี เอ แอล ลิสซิ่ง จำกัด ไป บริษัท วัน มันนี่ จำกัด"],
};

export const getSelectOptions = (list) =>
  Object.entries(list).map(([key, [value, label]]) => ({
    key,
    value,
    label,
  }));

export const optionsCompany = [...getSelectOptions(listCompany)];
